import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { loadAnalytics } from "@/lib/analytics";

const STORAGE_KEY = "origini-cookie-consent";

/**
 * Banner di consenso ai cookie. Gli strumenti di statistica (Google Analytics 4)
 * vengono caricati solo dopo l'accettazione. La scelta è salvata nel browser.
 */
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (choice === "accepted") {
      loadAnalytics();
    } else if (choice !== "rejected") {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    loadAnalytics();
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6">
      <div className="mx-auto max-w-3xl bg-card border border-border rounded-2xl shadow-2xl p-6 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-foreground/85 leading-relaxed flex-1">
          Usiamo cookie tecnici e, previo consenso, strumenti di statistica per migliorare
          il sito. Consulta la{" "}
          <Link to="/cookie-policy" className="text-primary underline hover:text-accent">
            Cookie Policy
          </Link>{" "}
          e la{" "}
          <Link to="/privacy" className="text-primary underline hover:text-accent">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <Button variant="outline" className="rounded-full" onClick={reject}>
            Rifiuta
          </Button>
          <Button className="rounded-full" onClick={accept}>
            Accetta
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
